module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>\n  <div ng-show="alertvisible" class="alert alert-info" role="alert">\n    <strong>La parcelle cliquée n\'a pas d\'adresse.</strong>\n  </div>\n  <table ng-show="visible">\n    <tr>\n      <td>Adresse la plus proche:</td>\n    </tr>\n    <tr>\n      <td>{{adresse}}</td>\n    </tr>\n    <tr>\n      <td>{{npa}} {{localite}}</td>\n    </tr>\n  </table>\n  <p ng-hide="visible">Il n\'y a pas d\'adresse<br />dans un rayon de 100m.</p>\n</div>\n';

}
return __p
}